var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.isActive ? 'active' : '', _vm.type],attrs:{"id":"toast"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }